import { InitialsPipe } from '../../../shared/pipes/initials.pipe';
import type { ChildOption } from '../models/child-option.model';

const initialsPipe = new InitialsPipe();

/** Text shown in the avatar circle when the child has no profile image. */
export function childAvatarFallbackLabel(
  child: Pick<ChildOption, 'initialsData' | 'name'>,
): string {
  return initialsPipe.transform(child.initialsData) || child.name?.[0] || '?';
}
